import { cn } from "@/lib/utils";

interface ToggleSwitchProps {
	on: boolean;
	onToggle: () => void;
	accent: string;
	label: string;
	labelledBy?: string;
}

function ToggleSwitch(prop: ToggleSwitchProps) {
	const { on, onToggle, accent, label, labelledBy } = prop;
	return (
		<button
			type="button"
			role="switch"
			aria-checked={on}
			aria-label={labelledBy ? undefined : label}
			aria-labelledby={labelledBy}
			onClick={onToggle}
			className="relative h-5 w-9 shrink-0 rounded-full transition-colors duration-300"
			style={{ background: on ? accent : "var(--surface-2)" }}
		>
			<span
				className={cn(
					"absolute top-0.5 start-0.5 h-4 w-4 rounded-full bg-white shadow-sm transition-transform duration-300",
					on && "translate-x-full rtl:-translate-x-full",
				)}
			/>
		</button>
	);
}

export default ToggleSwitch;
